import {OperatorProgression} from "../../../generated/protocol";
import {HttpService, HTTP_SERVICE_NAME} from "../http/HttpService";
import {AppCtx} from "../../ioc/ApplicationContext";
import {injectable} from "inversify";

export const OPERATOR_PROGRESSION_SERVICE_NAME = "operatorProgressionService";

export interface OperatorProgressionService {
    getOperatorProgression(operatorId: number): Promise<OperatorProgression>;

}

@injectable()
export class OperatorProgressionServiceImpl implements OperatorProgressionService {


    httpService: HttpService;

    constructor() {
        this.httpService = AppCtx.resolve<HttpService>(HTTP_SERVICE_NAME);
    }

    getOperatorProgression(operatorId: number): Promise<OperatorProgression> {
        return this.httpService.doGet("/operator/progression/" + operatorId);
    }

    createOrSave(progression: OperatorProgression): Promise<OperatorProgression> {
        return this.httpService.doPost("/operator/progresssion/", progression);
    }


}


// WEBPACK FOOTER //
// ./src/app/service/operator/OperatorProgressionService.ts